<template>
<v-container>
    <div class="home">
        <h1>
            just wait<br>{{this.msg}}
        </h1>

    </div>
</v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from '../apis/apifactory';
Vue.use(VueAxios, axios);
export default {
    name: "ExtraAuth",
    data: () => ({
        loginusername: null,
        loginusernametbd: null,
        userid: null,
        itemObj: null,
        msg: ''

    }),
    props: {
        user_id: {
            type: String,
            required: true,
            default: null
        },
        key: {
            type: String,
            required: true,
            default: null
        },
        app_id: {
            type: String,
            required: true,
            default: null
        }
    },
    mounted() {
        //localStorage.setItem('SET_USERID', this.user_id);
       // this.$router.push("/appview");
      
       this.getauthdata();
    },
    methods: {
       
        getauthdata() {
            //alert('dd');
            apifactory.getuserbyuserid(this.user_id)
                .then((res) => {
                     //alert(JSON.stringify(res));

                    if (res.status != 200) {
                        alert(res.data.message);

                    } else {
                        this.itemObj = res.data;
                        //alert(JSON.stringify(this.itemObj));
                        //alert(res.data.status);
                       
                        //alert(JSON.stringify(res.data.userlist.lenght));
                        if(res.data.userlist == null){
                            this.$router.push("/login");
                        }else{this.loginusername = res.data.userlist[0].username;
                        this.userid = res.data.userlist[0].id;
                        localStorage.setItem('SET_USERNAME', this.loginusername);
                        localStorage.setItem('SET_USERID', this.userid);
                       // alert(this.userid);
                        if (this.userid > 0) {

                            this.$router.push("/allapps");
                        } else {
                            this.msg = res.data.message;
                        }}
                        

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        goTo(url) {
            return this.$router.push(url);
        }
    }

};
</script>
